import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['input']

  connect() {
    this.abortController = null
  }

  search() {
    if (this.abortController) {
      this.abortController.abort()
    }

    this.abortController = new AbortController()

    this.debounceSubmit(this.abortController.signal)
  }

  debounceSubmit(signal) {
    const delay = 300

    new Promise((resolve, reject) => {
      const timeoutId = window.setTimeout(resolve, delay)
      signal.addEventListener('abort', () => {
        window.clearTimeout(timeoutId)
        reject(new DOMException('Aborted', 'AbortError'))
      })
    })
      .then(() => {
        this.element.requestSubmit()
      })
      .catch(() => {})
  }
}
